import { useState, useMemo } from 'react';
import SubPageHero from '@/components/SubPageHero';
import s from './Inquiry.module.scss';
import f from './Faq.module.scss';   // 탭·검색 스타일 재사용(시원시원)

/**
 * [2026-09-10] 자료실 — 공개(비회원). 안전/환경 탭 + 검색. 환경=evstech 실측 4건 연결, 안전=틀(차후 추가).
 *   실제 파일은 EVS 자료실(evstech) 상세에서 → 각 항목을 해당 상세로 링크(외부 새 탭).
 */
// [2026-09-10] 자료실 파일 — ★evstech(신규 사이트 완성 시 폐지 예정)에서 실제 PDF를 내려받아 ★내 서버 self-host★
//   (reactives/public/files/ → 배포 시 /files/ 로 서빙). type=pdf → 로컬 다운로드.
//   10838(관리제도 업무편람)만 evstech PDF가 없고 정부 그린링크 원문뿐 → 그린링크 링크(사용자 지정 '예외', 존속).
const DOCS: { tab: 'safety' | 'env'; title: string; tag: string; url: string; type: 'pdf' | 'link' }[] = [
	{ tab: 'env', title: '업무편람 주요사항 (2025. 7월)', tag: '업무편람', type: 'pdf', url: '/files/iot-manual-highlights-2025-07.pdf' },
	{ tab: 'env', title: '사물인터넷(IoT) 측정기기 관리제도 업무편람 (2025.6 제정)', tag: '업무편람', type: 'link', url: 'https://www.greenlink.or.kr/web/board/20/2640/?pMENU_ID=134' },
	{ tab: 'env', title: '사물인터넷 측정기기 설치 및 운영 가이드라인 (25.4.28 개정)', tag: '가이드라인', type: 'pdf', url: '/files/iot-install-guideline-2025-04-28.pdf' },
	{ tab: 'env', title: '사물인터넷 측정기기 설치 및 운영 가이드라인 (2023.6)', tag: '가이드라인', type: 'pdf', url: '/files/iot-install-guideline-2023-06.pdf' },
	// 안전: 차후 추가(틀만).
];

const IconSafety = <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l7 3v5c0 4.5-3 7.6-7 9-4-1.4-7-4.5-7-9V6z" /><path d="M9 12l2 2 4-4" /></svg>;
const IconEnv = <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><path d="M5 20c9 0 14-6 14-14 0 0-11-1-14 7-1.4 3.6 0 7 0 7z" /><path d="M5 20c2.5-6 7-8.5 11-9.5" /></svg>;
const IconSearch = <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.5" y2="16.5" /></svg>;
const IconDoc = <svg viewBox="0 0 24 24" style={{ width: 26, height: 26, stroke: '#1FB2EE', strokeWidth: 1.6, fill: 'none' }} strokeLinecap="round" strokeLinejoin="round"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" /><path d="M14 3v6h6M8 13h8M8 17h6" /></svg>;
const IconExt = <svg viewBox="0 0 24 24" style={{ width: 18, height: 18, stroke: '#8299ab', strokeWidth: 1.8, fill: 'none' }} strokeLinecap="round" strokeLinejoin="round"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" /></svg>;

const TABS = [
	{ key: 'safety', name: '안전 (온열질환)', icon: IconSafety },
	{ key: 'env', name: '환경 (대기배출)', icon: IconEnv },
];

export default function Resources() {
	const [tab, setTab] = useState<'safety' | 'env'>('env');
	const [kw, setKw] = useState('');

	const list = useMemo(() => {
		const q = kw.trim().toLowerCase();
		return DOCS.filter((d) => (q ? d.title.toLowerCase().includes(q) : d.tab === tab));
	}, [tab, kw]);

	return (
		<>
			<SubPageHero title="자료실" subtitle="설치·운영 가이드라인 등 제품 관련 자료를 확인하세요"
				image="/images/auth/hero.jpg" crumbs={[{ label: 'HOME' }, { label: '고객지원' }, { label: '자료실' }]} />
			<div className={f.wrap}>
				<div className={f.inner}>
					<div className={f.search}>
						{IconSearch}
						<input value={kw} onChange={(e) => setKw(e.target.value)} placeholder="자료 제목을 검색하세요" />
					</div>

					{!kw.trim() && (
						<div className={f.tabs}>
							{TABS.map((t) => (
								<button key={t.key} className={`${f.tab} ${tab === t.key ? f.on : ''}`} onClick={() => setTab(t.key as 'safety' | 'env')}>
									{t.icon}{t.name}
								</button>
							))}
						</div>
					)}

					{list.length === 0 ? (
						<div className={f.empty}>{kw.trim() ? '검색 결과가 없습니다.' : '해당 분야 자료는 준비 중입니다. 순차적으로 등록될 예정입니다.'}</div>
					) : (
						<div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
							{list.map((d) => (
								<a key={d.url} href={d.url} target="_blank" rel="noopener noreferrer" {...(d.type === 'pdf' ? { download: '' } : {})}
									style={{ display: 'flex', alignItems: 'center', gap: 20, padding: '26px 28px', background: '#fff', border: '1.5px solid #e5eaf0', borderRadius: 16, textDecoration: 'none', transition: 'border-color .15s, box-shadow .15s' }}
									onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#1FB2EE'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(31,178,238,.08)'; }}
									onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e5eaf0'; e.currentTarget.style.boxShadow = 'none'; }}>
									<span style={{ flex: '0 0 auto', width: 52, height: 52, borderRadius: 12, background: '#eef7fd', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{IconDoc}</span>
									<span style={{ flex: 1 }}>
										<span style={{ display: 'inline-block', fontSize: 11.5, fontWeight: 700, color: '#0b84b3', background: '#e7f6fd', borderRadius: 20, padding: '3px 10px', marginBottom: 8 }}>{d.tag}</span>
										<span style={{ display: 'block', fontSize: 17, fontWeight: 700, color: '#222833', lineHeight: 1.45 }}>{d.title}</span>
									</span>
									<span style={{ flex: '0 0 auto', display: 'flex', alignItems: 'center', gap: 6, fontSize: 13.5, fontWeight: 700, color: d.type === 'pdf' ? '#1FB2EE' : '#8299ab' }}>{d.type === 'pdf' ? 'PDF 다운로드' : '원문 보기'} {IconExt}</span>
								</a>
							))}
						</div>
					)}

					<p className={f.foot} style={{ marginTop: 30 }}>필요한 자료가 더 있으시면 <a href="/support/inquiry">문의하기</a>로 요청해주세요.</p>
				</div>
			</div>
		</>
	);
}
